import { Project } from '../../../../../../domain/project/Project';
import { FieldDefinition } from './FieldDefinitions';

const commonFields: FieldDefinition[] = [
  {
    id: `external_id`,
    type: `text`,
  },
  {
    id: `label`,
    type: `text`,
  },
];

export const getTaskFields = (project: Project) => {
  const clientFields = [...commonFields];
  const enabledFields = project.view.task;
  const customFields = project.custom_fields?.task || [];

  if (enabledFields.barcode) {
    clientFields.push({
      id: `barcode`,
      type: `text`,
    });
  }
  if (enabledFields.comments) {
    clientFields.push({
      id: `comments`,
      type: `text`,
    });
  }

  customFields.forEach((field) => {
    if (field.enabled) {
      if (field.field_type === `categorical`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          options: field.options as string[],
          isMultipleChoice: field.multiple || false,
          isCustomField: true,
        });
      } else if (field.field_type === `numerical`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      } else if (field.field_type === `text`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      } else if (field.field_type === `boolean`) {
        clientFields.push({
          id: field.custom_id,
          type: field.field_type,
          label: field.label,
          isCustomField: true,
        });
      }
    }
  });

  return clientFields;
};
